/**
 * 诱导弹窗
 * */
import { Button } from '@mui/material';
import { useMount } from 'ahooks';
import Decimal from 'decimal.js';

import { implog } from '@/api/implog';
import fish_icon from '@/assets/home/tab_fish_active.webp';
import { IconArrowDown } from '@/components/icons/icons';
import BlurryLoadingImage from '@/components/progressive-img';
import useEntrygame from '@/hooks/useEntryGame';
import globalStore from '@/stores/store';
import { toFixed } from '@/utils/utils';

import styles from './styles.module.less';

export const FishInModal = (modal, onClose, innerProps: any = {}) => {
  const { pack, img } = innerProps;
  const { runEntry } = useEntrygame();

  useMount(() => {
    implog('receive_modal_show');
  });

  return (
    <div className={styles.main}>
      <BlurryLoadingImage
        loading="lazy"
        src={img}
        style={{ width: '2.56rem', display: 'block', margin: '0.4rem auto 0' }}
      />
      <div className={styles.content}>
        <div className={styles.text}>${toFixed(globalStore.initialFreeWithdrawInfo.score)}</div>
        <IconArrowDown
          style={{ color: 'var(--thirdColor)', width: '0.46rem', height: '0.34rem', margin: '0.1rem auto' }}
        />
        <div className={styles.amount}>
          <BlurryLoadingImage loading="lazy" src={fish_icon} style={{ width: '0.32rem', marginRight: '0.1rem' }} />
          <span>{new Decimal(toFixed(globalStore.initialFreeWithdrawInfo.score)).mul(100).toString()}</span> Points
        </div>
      </div>
      <div className={styles.content_desc}>
        Your balance will be converted into <br />{' '}
        <span>{new Decimal(toFixed(globalStore.initialFreeWithdrawInfo.score)).mul(100).toString()}</span> game points
        for gameplay. <br /> Enjoy the excitement and fun.
      </div>
      <Button
        sx={{
          width: '5.4rem',
          height: '0.7rem',
          borderRadius: '0.9rem',
          fontWeight: 700,
          fontSize: '0.28rem',
          color: '#fff',
          background: '#FFAB1A',
          marginTop: '1.12rem'
        }}
        className="global_button_succes"
        onClick={async () => {
          await runEntry(pack);
        }}
      >
        Play
      </Button>
    </div>
  );
};

export const FishOutModal = (modal, onClose, innerProps: any = {}) => {
  const { img } = innerProps;

  useMount(async () => {
    implog('receive_modal_show');
  });

  return (
    <div className={styles.main}>
      <BlurryLoadingImage
        loading="lazy"
        src={img}
        style={{ width: '2.56rem', display: 'block', margin: '0.4rem auto 0' }}
      />
      <div className={styles.content}>
        <div className={styles.amount}>
          <BlurryLoadingImage loading="lazy" src={fish_icon} style={{ width: '0.32rem', marginRight: '0.1rem' }} />
          <span>{new Decimal(toFixed(globalStore.initialFreeWithdrawInfo.score)).mul(100).toString()}</span> Points
        </div>
        <IconArrowDown style={{ color: '#FFD118', width: '0.46rem', height: '0.34rem', margin: '0.1rem auto' }} />
        <div className={styles.text}>${toFixed(globalStore?.initialFreeWithdrawInfo?.score || 0)}</div>
      </div>
      <div className={styles.content_desc}>
        Your remaining points in the game have been transferred to your wallet balance at a ratio of
        <span> 100:1</span>.
      </div>
      <Button
        sx={{
          width: '5.4rem',
          height: '0.7rem',
          borderRadius: '0.9rem',
          fontWeight: 700,
          fontSize: '0.28rem',
          color: '#fff',
          background: '#FFAB1A',
          marginTop: '1.12rem'
        }}
        className="global_button_succes"
        onClick={async () => {
          modal.resolve({ onClose });
        }}
      >
        OK
      </Button>
    </div>
  );
};
